import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Building on the examples above, here are a few things you can do with groups:`}</p>
    <ol>
      <li parentName="ol">{`Track how `}<strong parentName="li">{`companies`}</strong>{` progress through your B2B product's activation steps. For example, you can create a `}<a parentName="li" {...{
          "href": "/docs/product-analytics/funnels"
        }}>{`funnel`}</a>{` to see:`}
        <ul parentName="li">
          <li parentName="ul">{`How many companies signed up this month.`}</li>
          <li parentName="ul">{`What percentage completed the onboarding flow.`}</li>
          <li parentName="ul">{`What percentage of new companies interacted with specific features at least once.`}</li>
        </ul>
      </li>
    </ol>
    <br />
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`If you're building a Slack-like app, you can measure `}<a parentName="li" {...{
          "href": "/docs/product-analytics/retention"
        }}>{`retention`}</a>{` of new features by specific `}<strong parentName="li">{`channels`}</strong>{`. For example:`}
        <ul parentName="li">
          <li parentName="ul">{`Which channels consistently use the video calling feature.`}</li>
          <li parentName="ul">{`How many channels remain active month over month.`}</li>
          <li parentName="ul">{`Compare feature adoption rates between different types of channels (e.g., team channels vs project channels).`}</li>
        </ul>
      </li>
    </ol>
    <br />
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`For collaborative, project-based apps like Jira, you can target `}<a parentName="li" {...{
          "href": "/docs/feature-flags"
        }}>{`feature flags`}</a>{` at a project-level. For example, let's say you've refactored your codebase. You can target the new codebase to only a few projects and measure the impact on performance and errors metrics. Once you've gathered feedback, you can expand to the rest of your projects.`}</li>
    </ol>
    <p>{`Here's an overview to how groups can be applied across PostHog:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Product`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Functionality`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Product analytics`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Aggregate trends, funnels, retention, and stickiness by group.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create a funnel to track how many companies completed your onboarding flow.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Feature flags`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Configure release conditions based on groups.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ensure all users of a given company receive the same feature flag variant.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Experiments`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Evaluate experiment results based on group aggregations.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Run an A/B test to improve activation rate for new companies.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Data warehouse`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Join tables or enrich queries with groups data.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Write a custom SQL query that calculates product usage based across different company sizes.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      